module.exports = __webpack_public_path__ + "static/media/parceiro(12).37756f06.png";